import { render, staticRenderFns } from "./ProdutcsDetail.vue?vue&type=template&id=7def1677&scoped=true&"
import script from "./ProdutcsDetail.vue?vue&type=script&lang=js&"
export * from "./ProdutcsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProdutcsDetail.vue?vue&type=style&index=0&id=7def1677&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def1677",
  null
  
)

export default component.exports